import './setup';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { XMTPProvider } from './context/XMTPContext';
import reportWebVitals from './reportWebVitals';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <XMTPProvider>
      <App />
    </XMTPProvider>
  </React.StrictMode>
);

reportWebVitals();
